import { MatcherName, registerLocallyHandledErrorMatcher, singleErrorMatcher, } from 'api/locallyHandledErrors';
const errorMatcher = singleErrorMatcher({
    message: 'DataValidationException',
    operationName: 'SetOrderSpecificationProductionStartDate',
});
const registerOrderSpecificationAllocationIncompleteErrorMatcher = () => registerLocallyHandledErrorMatcher(MatcherName.OrderSpecificationAllocationIncomplete, errorMatcher);
export default registerOrderSpecificationAllocationIncompleteErrorMatcher;
